import React from 'react';
import { Card, CardContent } from '../ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { brl, pct, num, days } from './format';

export const FormasSection = ({ rows, unidade }) => (
  <div className="grid gap-4 lg:grid-cols-5">
    <Card className="min-w-0 lg:col-span-2">
      <CardContent className="p-4">
        <p className="text-sm text-muted-foreground mb-2">Participação nos pedidos (%)</p>
        <div style={{ width: '100%', height: Math.max(180, rows.length * 44) }} data-testid="logistics-formas-chart">
          <ResponsiveContainer>
            <BarChart data={rows} layout="vertical" margin={{ left: 10, right: 20 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" horizontal={false} />
              <XAxis type="number" tick={{ fontSize: 11 }} unit="%" />
              <YAxis type="category" dataKey="forma_entrega" width={120} tick={{ fontSize: 11 }} />
              <Tooltip formatter={(v) => pct(v)} />
              <Bar dataKey="share" name="% dos pedidos" fill="#5B5BD6" radius={[0, 4, 4, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
    <Card className="min-w-0 lg:col-span-3">
      <CardContent className="p-4 overflow-x-auto">
        <table className="w-full text-sm" data-testid="logistics-formas-table">
          <thead>
            <tr className="border-b text-muted-foreground">
              <th className="py-2 px-2 text-left font-medium">Forma de entrega</th>
              <th className="py-2 px-2 text-right font-medium">% pedidos</th>
              <th className="py-2 px-2 text-right font-medium">Frete médio</th>
              <th className="py-2 px-2 text-right font-medium">Prazo médio</th>
              <th className="py-2 px-2 text-right font-medium">% grátis</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.forma_entrega} className="border-b last:border-0" data-testid="logistics-forma-row">
                <td className="py-2 px-2">
                  <p className="font-medium">{r.forma_entrega}</p>
                  {r.transportadora && <p className="text-xs text-muted-foreground">{r.transportadora}</p>}
                  <p className="text-[11px] text-muted-foreground">{num(r.pedidos)} pedidos</p>
                </td>
                <td className="py-2 px-2 text-right font-mono">{pct(r.share)}</td>
                <td className="py-2 px-2 text-right font-mono">{brl(r.frete_medio)}</td>
                <td className="py-2 px-2 text-right font-mono whitespace-nowrap">{days(r.prazo_medio, r.prazo_unidade || unidade)}</td>
                <td className="py-2 px-2 text-right font-mono">{pct(r.pct_gratis)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </CardContent>
    </Card>
  </div>
);
